/**
 * loader between searches
 */

import { dId, logger } from "./utils";
import { langDict } from "./dict";
import { call_results } from "./results_functions";

declare const IMAGE_BASE: string;

let ticktock: number;
let sTime: number;
const cTime: number = 6000;		// ! set back to 600 when live. 

let loadTimer: number;
let loaderWord_count = -1;


function show_loader() {

	logger("show loader", "log");

  const src = <HTMLElement>dId("looking");
  src.classList.remove("hidden");
  loaderWords();

}


function hide_loader() {

	logger("hide loader", "log");

	const src = <HTMLElement>dId("looking");
	const target = <HTMLElement>dId("loaderWordSet");

	src.classList.add("hidden");
	target.classList.remove("animate");
	target.innerHTML = "";

	clearTimeout(loadTimer);

}




function loaderWords() {

	const city_w = (<HTMLInputElement>dId("f_ciudad")).value;

	const words = [
			langDict[80] + city_w,
			langDict[81] + city_w,
			langDict[82]
	];

	loaderWord_count += 1;
	if (loaderWord_count > 2) {
		loaderWord_count = 0;
	}

	logger("show word " + loaderWord_count, "log");

	const target = <HTMLElement>dId("loaderWordSet");
	target.classList.remove("animate");
	target.innerHTML = "";

	setTimeout(() => {
		target.innerHTML = words[loaderWord_count];
		target.classList.add("animate");
	}, 50);
	
	loadTimer = setTimeout(loaderWords, 3050);
		
}




/** Warn clients of impending doom and the loss of their prices */
function start_tick() {
	
	(<HTMLElement>dId("ticker")).style.display = "none";

	end_tick();

	sTime = (new Date).getTime();
	ticktock = setInterval(updateTime, 500);

}


/** Warn clients of impending doom and the loss of their prices */
function end_tick() {
	
	(<HTMLElement>dId("ticker")).style.display = "none";

	try {
		clearInterval(ticktock);
	} catch (err) {
		logger("No timeout to clear", "error");
	}

}


function updateTime() {

	let nTime = (new Date).getTime();
	let diff = nTime - sTime;
	let seconds = cTime - Math.floor(diff / 1e3);

	const target = <HTMLElement>dId("ticker");

	if (seconds <= 1.5) {

		target.style.display = "none";
		clearInterval(ticktock);
		call_results();

	} else if (seconds <= 50 && seconds >= 2) {

		target.style.display = "block";

	}

	// TODO: Dictionary for english version of this string: 
	target.innerHTML = `<span>Solo dispones de ${seconds} segundos más para completar la reserva`;
}



// TODO - See where called: 
function messageShow(target:string, s:string) {
	(<HTMLElement>dId(target)).innerHTML = s;
	(<HTMLElement>dId(target)).classList.add("show");
}


export { show_loader, hide_loader, start_tick, end_tick }